import $ from "jquery";

(function() {
  $(document).ready(function() {
    const NO_ICON_TABLE_CELL_LOCATOR =
      ".comparison-table tr.comparison-upper-row .comparison-cell.comparison-cell__upper.comparison-cell__no-icon";
    // execute above function
    if (document.getElementsByClassName("block-comparison-table").length) {
      if ($(window).width() < 768) {
        $(NO_ICON_TABLE_CELL_LOCATOR).attr("rowspan", "1");
      } else {
        $(NO_ICON_TABLE_CELL_LOCATOR).attr("rowspan", "2");
      }

      $(window).on("resize", function() {
        if ($(this).width() < 768) {
          $(NO_ICON_TABLE_CELL_LOCATOR).attr("rowspan", "1");
          $(
            ".comparison-table tr.comparison-upper-row.open .comparison-cell.comparison-cell__upper.comparison-cell__no-icon"
          ).attr("rowspan", "2");
        } else {
          $(NO_ICON_TABLE_CELL_LOCATOR).attr("rowspan", "2");
        }
      });

      $(".comparison-table tr.comparison-upper-row").on("click", function(
        event
      ) {
        if ($(window).width() < 768) {
          event.preventDefault();
          $(this)
            .toggleClass("open")
            .next()
            .toggleClass("open");

          let noIconCells = $(this).find(
            ".comparison-cell.comparison-cell__upper.comparison-cell__no-icon[rowspan='2']"
          );
          if (noIconCells.length > 0) {
            noIconCells.attr("rowspan", "1");
          } else {
            $(this)
              .find(
                ".comparison-cell.comparison-cell__upper.comparison-cell__no-icon[rowspan='1']"
              )
              .attr("rowspan", "2");
          }
        }
      });
    }
  });
})();

// Also add listener on resize



// WEBPACK FOOTER //
// ./client/src/site__scf001/components/blocks/comparison-table/index.js